import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Analytics.css';
import VerificationCount from "./VerificationCountAnalytics";
import QRsPerProduct from "./QRsPerProductAnalytics";
import QRGeneration from "./QRGenerationAnalytics";
import Maps from "./Map";

const TABS = [
  {
    id: 'chart3',
    label: 'Verification Count',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
      </svg>
    ),
  },
  {
    id: 'chart1',
    label: "QRs per Product",
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" />
        <rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" />
      </svg>
    ),
  },
  {
    id: 'chart2',
    label: 'QR Generation Timeline',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
      </svg>
    ),
  },
  {
    id: 'chart4',
    label: 'Maps',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6" />
        <line x1="8" y1="2" x2="8" y2="18" /><line x1="16" y1="6" x2="16" y2="22" />
      </svg>
    ),
  },
];

function Analytics() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(
    sessionStorage.getItem('chart') || 'chart3'
  );

  const switchTab = (tab) => {
    sessionStorage.setItem('chart', tab);
    setActiveTab(tab);
  };

  useEffect(() => {
    if (sessionStorage.getItem('isLoggedIn') !== "true") {
      navigate('/');
    }
  }, [navigate]);

  const activeTabLabel = TABS.find(t => t.id === activeTab)?.label || '';

  return (
    <div className="analytics-page">
      {/* Top Header */}
      <header className="dashboard-header">
        <button onClick={() => navigate('/dashboard')} className="back-button">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="19" y1="12" x2="5" y2="12" /><polyline points="12 19 5 12 12 5" />
          </svg>
          Dashboard
        </button>
      </header>

      {/* Main Body */}
      <div className="analytics-body">
        {/* Sidebar */}
        <aside className="analytics-sidebar">
          <nav className="sidebar-nav">
            {TABS.map(({ id, label, icon }) => (
              <button
                key={id}
                className={`sidebar-tab ${activeTab === id ? 'active' : ''}`}
                onClick={() => switchTab(id)}
              >
                <span className="tab-icon">{icon}</span>
                <span className="tab-label">{label}</span>
                {activeTab === id && <span className="active-indicator" />}
              </button>
            ))}
          </nav>
        </aside>

        {/* Chart Area */}
        <main className="analytics-main">
          <div className="chart-panel">
            <div className="chart-panel-body">
              {activeTab === 'chart1' && <QRsPerProduct />}
              {activeTab === 'chart2' && <QRGeneration />}
              {activeTab === 'chart3' && <VerificationCount />}
              {activeTab === 'chart4' && <Maps />}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default Analytics;